<template>
  <!-- Page Content -->
  <div class="h-100 d-flex flex-column">
    <div class="row f-row justify-content-center h-100">
      <!-- First Column -->
      <transition name="fadeCharts" v-if="!hideLeft">
        <div
          class="col text-center"
          v-bind:class="[expandLeft ? 'col-12' : '', 'col-5']"
        >
          <div class="h-100 d-flex flex-column">
            <!-- 2 Charts Column -->
            <div class="row f-row h-100">
              <div class="col col-12" style="height:100%; width:100%">
                <!-- Chart 1 -->
                <div class="h-50 d-flex flex-column" style="width: 100%;">
                  <!-- Row: title -->

                  <div class="row f-row">
                    <div
                      class="txt-label-primary-2 markets-chart-title text-left d-flex bdr-b container-title--select"
                      style="width: 100%!important;"
                    >
                      <span class="mr-auto">
                        <span v-if="showLoadingAll" class="inh text-left mr-2">
                          <QSLoading
                            :isLoading="showLoadingAll"
                            :size="20"
                            :colorTheme="colorTheme"
                          />
                        </span>
                        Select asset:
                        <span class="inh text-left mr-2">
                          <Dropdown
                            v-model="pickedAsset"
                            :options="
                              variables.map((d, i) => ({ asset: d, id: i }))
                            "
                            @change="_pickedAsset"
                            optionLabel="asset"
                            optionValue="id"
                            placeholder="Select Variable"
                            scrollHeight="400px"
                          >
                            <template #value="slotProps">
                              {{ variables[slotProps.value] }}
                            </template>
                            <template #option="slotProps">
                              <div class="country-item">
                                <div>{{ slotProps.option.asset }}</div>
                              </div>
                            </template>
                          </Dropdown>
                        </span>
                      </span>
                      <div class="container-sidebarHidden">
                        <div class="sidebarHidden">
                          <button
                            @click="expandLeftAnimation()"
                            class="btn mr-1"
                            style="width: 12px;"
                          >
                            <i class="fa fa-expand" v-if="!expandLeft"></i>
                            <i class="fa fa-compress" v-if="expandLeft"></i>
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                  <!-- Row: Chart -->
                  <div class="row f-row h-100">
                    <div
                      class="col col-12 text-center progress-div"
                      style="top: 22.5%!important;"
                      v-if="showLoadingAll"
                    >
                      <QSLoading
                        :isLoading="showLoadingAll"
                        :size="35"
                        :colorTheme="colorTheme"
                      />
                    </div>
                    <div
                      class="col col-12 text-center"
                      v-else-if="chartData.length === 0"
                      style="position: absolute; left: 0; top: 27.5%; z-index: 10000000;"
                    >
                      No Data Available
                    </div>
                    <div
                      class="col col-12"
                      style="height:100%; width:100%; position: relative;"
                    >
                      <!-- Row: legend -->
                      <div class="row f-row first-legends-container">
                        <div class="col col-10 text-left">
                          <table
                            class="table table-sm table-responsive table-borderless table-market-legend"
                            style="width: 100%; background: rgba(0,0,0,0)"
                          >
                            <tbody>
                              <tr>
                                <td>
                                  <i
                                    class="fa fa-minus mr-1"
                                    style="color:var(--expo)"
                                  ></i
                                  >{{ currencyString.currency_name }} (left)
                                </td>
                                <td>
                                  <i
                                    class="fa fa-minus mr-1"
                                    style="color:var(--graylightbackground)"
                                  ></i
                                  >{{ variables[pickedAsset] }} (right)
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                      <div
                        class="h-100 d-flex flex-column"
                        id="comparison-div"
                        style="width: 100%;"
                      >
                        <svg id="svg-comparison"></svg>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Chart 2 -->
                <div class="h-50 d-flex flex-column" style="width: 100%;">
                  <!-- Row: title -->
                  <div class="row f-row">
                    <div class="markets-chart-title col col-12">
                      Return correlation (&#961;)
                    </div>
                  </div>
                  <!-- Row: Chart -->
                  <div class="row f-row h-100">
                    <div
                      class="col col-12 text-center progress-div"
                      style="top: 74.5%!important;"
                      v-if="showLoadingAll"
                    >
                      <QSLoading
                        :isLoading="showLoadingAll"
                        :size="35"
                        :colorTheme="colorTheme"
                      />
                    </div>
                    <div
                      class="col col-12 text-center"
                      v-else-if="chartData.length === 0"
                      style="position: absolute; left: 0; top: 77.5%; z-index: 10000000;"
                    >
                      No Data Available
                    </div>
                    <div class="col col-12" style="height:100%; width:100%">
                      <div
                        class="h-100 d-flex flex-column"
                        id="correlation-div"
                        style="width: 100%;"
                      >
                        <svg id="svg-correlation"></svg>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </transition>

      <!-- ======================== //// ============================== -->
      <!-- Second Column -->
      <transition name="fadeCharts" v-if="!hideRight">
        <div
          class="col text-center results-divider"
          v-bind:class="[expandRight ? 'col-12' : '', 'col-7']"
        >
          <div class="h-100 d-flex flex-column">
            <!-- Row: title and resize button -->
            <div class="row f-row">
              <div
                class="txt-label-primary-2 markets-chart-title text-left d-flex bdr-b"
                style="width: 100%!important;"
              >
                <div class="col col-11">
                  <slot name="spot"></slot>
                </div>
                <div class="col col-1 container-sidebarHidden">
                  <div class="sidebarHidden col col-1">
                    <button
                      @click="expandRightAnimation()"
                      class="btn mr-1"
                      style="width: 12px;"
                    >
                      <i class="fa fa-expand" v-if="!expandRight"></i>
                      <i class="fa fa-compress" v-if="expandRight"></i>
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <!-- Row: controls and labels -->
            <div
              class="row f-row mt-2"
              id="relValControls"
              style="vertical-align: middle!important; padding: 0 60px 0 12px;"
            >
              <div
                class="col"
                :class="this.screenWidth > 1200 && 'col-2'"
              ></div>
              <div
                class="col"
                :class="
                  this.screenWidth > 1400
                    ? 'col-9'
                    : this.screenWidth > 1200
                    ? 'col-10'
                    : 'col-12'
                "
                style="background: var(--background); border: 1px solid var(--lightbackground)"
              >
                <table
                  class="table table-sm table-borderless table-data-controls"
                  style="width: 100%;"
                >
                  <tbody>
                    <tr class="txt-label-primary-5">
                      <td class="txt-label-primary-5">
                        Date:
                      </td>
                      <td class="txt-label-primary-5">
                        {{ variables[pickedAsset] }}:
                      </td>
                      <td class="txt-label-primary-5">
                        {{ currencyString.currency_name }}:
                      </td>
                      <td class="txt-label-primary-5">
                        Relative value:
                      </td>
                    </tr>
                    <tr>
                      <td class="txt-label-primary">
                        <div
                          id="relValDate"
                          class="candle-hover-info text-center"
                        >
                          -
                        </div>
                      </td>
                      <td
                        class="txt-label-primary"
                        style="color: var(--whiteGray)"
                      >
                        <div
                          id="relValRef"
                          class="candle-hover-info text-center"
                        >
                          -
                        </div>
                      </td>
                      <td
                        class="txt-label-primary"
                        style="color: var(--symmetry)"
                      >
                        <div
                          id="relValClose"
                          class="candle-hover-info text-center"
                        >
                          -
                        </div>
                      </td>
                      <td class="txt-label-primary">
                        <div id="rvHover" class="candle-hover-info text-center">
                          {{ rv | priceFormat }}
                          <i class="fa fa-long-arrow-up" v-if="spot < rv"></i>
                          <i class="fa fa-long-arrow-down" v-else></i>
                          <sup>
                            {{ (rv - spot) | priceFormatTwoDecimal }}
                          </sup>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <!-- Row: Chart -->
            <div class="row f-row h-100">
              <div
                class="col col-12 text-center progress-div"
                v-if="showLoadingAll"
              >
                <QSLoading
                  :isLoading="showLoadingAll"
                  :size="35"
                  :colorTheme="colorTheme"
                />
              </div>
              <div
                class="col col-12 text-center"
                v-else-if="chartData.length === 0"
                style="position: absolute; left: 0; top: 45%; z-index: 10000000;"
              >
                Failed to fetch data.<br />Please refresh page or contact
                support.
              </div>
              <div
                class="col col-12"
                style="height:100%; width:100%; position: relative;"
              >
                <!-- Row: legend -->
                <div class="row f-row second-legends-container">
                  <div class="col col-10 text-left">
                    <table
                      class="table table-sm table-responsive table-borderless table-market-legend"
                      style="width: 100%; background: rgba(0,0,0,0)"
                    >
                      <tbody>
                        <tr>
                          <td class="text-left" style="width:5.5%;">
                            <div class="triangle-topleft"></div>
                            <span class="inline-ul ml-1">Up / down</span>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
                <div class="h-100 d-flex flex-column" id="rel_val-div">
                  <svg id="svg-rel_val"></svg>
                </div>
              </div>
            </div>
          </div>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
// 3rd party packages
import { format, select } from "d3";
// Charts
import { D3Chart } from "@/_core/charts/D3Chart";
import {
  D3HoverRV,
  D3HoverRVForecast,
} from "@/_core/charts/D3ChartHoverEffects";
// Formats
import {
  colorExpo,
  colorFwd,
  colorSelectionVol,
  darkFwdAlpha2,
  dnCandles,
  grayLightBackground,
  textactive,
  whiteGray,
  colorExpoAlpha,
} from "@/_core/_helpers/_parametric_tools";
// Helpers
import { lengthByDate, noLiquidity } from "@/_core/_helpers/_helpers";
// Queries
import { getCorrelations } from "@/_core/data/api_calls/relatives_values/correlations/getCorrelations";
import { getHistData } from "@/_core/data/api_calls/relatives_values/historical/getHistData";
import { getModelData } from "@/_core/data/api_calls/relatives_values/model/getModelData";
import Dropdown from "primevue/dropdown";
import QSLoading from "@/components/QSLoading.vue";

export default {
  name: "RelativeValue",
  components: {
    QSLoading,
    Dropdown,
  },
  props: {
    colorTheme: { required: true, type: Boolean, default: true },
    contract: { required: false },
    currencyNumber: { required: true },
    currencyString: { required: true },
    dataReady: { required: true },
    expandRight: { required: true },
    hideLeft: { required: true },
    isCurrency: { required: true },
    processData: { required: true },
    spot: { required: true },
  },
  data() {
    return {
      // ========== Animations =============
      hideRight: false,
      expandLeft: false,

      // ========== Data =============
      showLoadingModel: false,
      showLoadingHistory: false,
      showLoadingCorrel: false,
      D3Chart: null,
      D3HoverRV: null,
      D3HoverRVForecast: null,
      D3ChartComparison: null,
      D3ChartCorrelation: null,
      svgNode: null,
      svgNodeComp: null,
      svgNodeCorr: null,
      dateFormat: "%d %b %y",
      currencyFormat: ",.4r",
      histData: [],
      correlation: [],
      relativeValue: [],
      rv: 0,
      dateList: [],
      models: [],
      priceModel: [],
      retModel: [],
      valuationInputs: [],
      variables: [],
      variablesId: [],
      columns: [],
      correlColumns: [],
      correlColNames: [],
      correlLongNames: [],
      selectedColumn: "",
      pickedAsset: 0,
      selectedDays: 130,
      minMaxYAxis: [1000000, -1000000],
      minMax1YAxis: [1000000, -1000000],
      minMax2YAxis: [1000000, -1000000],
      colorSel: JSON.parse(
        JSON.stringify(colorSelectionVol(this.colorTheme)),
      ).reverse(),
      color: [],
      chartData: [],
      chart2Data: [],
      screenWidth: 0,
      isCandles: null,
    };
  },
  created() {
    this.D3Chart = new D3Chart("rel_val-div", "svg-rel_val");
    this.D3ChartComparison = new D3Chart("comparison-div", "svg-comparison");
    this.D3ChartCorrelation = new D3Chart("correlation-div", "svg-correlation");
    this.D3HoverRV = new D3HoverRV();
    this.D3HoverRVForecast = new D3HoverRVForecast();
    this.showLoadingModel = true;
    this.showLoadingHistory = true;
    this.showLoadingCorrel = true;

    let initDate = new Date();
    let endDate = new Date();
    endDate.setMonth(endDate.getMonth() + 3, endDate.getDay());
    this.dateList = this.processData.createWorkingDays(initDate, endDate);

    let asset = this.isCurrency ? "currency" : "commodity";

    getModelData(this, asset, {
      commodityNumber: this.currencyNumber,
      contract: this.contract,
    });
    getHistData(this, asset, {
      commodityNumber: this.currencyNumber,
      contract: this.contract,
    });
    getCorrelations(this, asset, {
      commodityNumber: this.currencyNumber,
      contract: this.contract,
    });
  },
  mounted() {
    this.colorSel = JSON.parse(
      JSON.stringify(colorSelectionVol(this.colorTheme)),
    ).reverse();
    this.color = this.processData.setD3ColorFunction(this.colorSel, [
      -1,
      -0.75,
      -0.5,
      -0.25,
      0,
      0.25,
      0.5,
      0.75,
      1,
    ]);
    if (!this.isCurrency) {
      this.currencyString["currency_name"] =
        this.currencyString.fk_idproduct.toUpperCase() +
        " " +
        this.currencyString.selected_contract;
    }

    let _this = this;
    this.updateScreenWidth();
    window.addEventListener("resize", function() {
      _this.callWidth();
    });
  },
  computed: {
    showLoadingAll() {
      return (
        this.showLoadingCorrel ||
        this.showLoadingHistory ||
        this.showLoadingModel
      );
    },
  },
  watch: {
    colorTheme() {
      this.colorSel = JSON.parse(
        JSON.stringify(colorSelectionVol(this.colorTheme)),
      ).reverse();
      this.color = this.processData.setD3ColorFunction(this.colorSel, [
        -1,
        -0.75,
        -0.5,
        -0.25,
        0,
        0.25,
        0.5,
        0.75,
        1,
      ]);
      this.callWidth();
    },
    showLoadingAll(val) {
      if (val === false) {
        this.dataPrep();
        this.getColumn();
        this.valuateRV();
        this.addNames();
        this.renderComparisonChartMethod();
        this.renderCorrelationsMethod();
        this.renderMainChartMethod();
      } else {
        select("#rel_val-div")
          .select("svg > *")
          .remove();
        select("#comparison-div")
          .select("svg > *")
          .remove();
        select("#correlation-div")
          .select("svg > *")
          .remove();
        select("#rel_val-div")
          .selectAll(".tooltip")
          .remove();
        select("#comparison-div")
          .selectAll(".tooltip")
          .remove();
        select("#correlation-div")
          .selectAll(".tooltip")
          .remove();
      }
    },
    currencyString() {
      if (!this.isCurrency) {
        this.currencyString["currency_name"] =
          this.currencyString.fk_idproduct.toUpperCase() +
          " " +
          this.currencyString.selected_contract;
      }
      this.showLoadingModel = true;
      this.showLoadingHistory = true;
      this.showLoadingCorrel = true;
      this.chartData = [];
      this.correlation = [];
      select("#rel_val-div")
        .select("svg > *")
        .remove();
      select("#comparison-div")
        .select("svg > *")
        .remove();
      select("#correlation-div")
        .select("svg > *")
        .remove();
      select("#rel_val-div")
        .selectAll(".tooltip")
        .remove();
      select("#comparison-div")
        .selectAll(".tooltip")
        .remove();
      select("#correlation-div")
        .selectAll(".tooltip")
        .remove();

      let asset = this.isCurrency ? "currency" : "commodity";
      getModelData(this, asset, {
        commodityNumber: this.currencyNumber,
        contract: this.contract,
      });
      getHistData(this, asset, {
        commodityNumber: this.currencyNumber,
        contract: this.contract,
      });
      getCorrelations(this, asset, {
        commodityNumber: this.currencyNumber,
        contract: this.contract,
      });
    },
  },
  filters: {
    priceFormat: function(val) {
      return val === null || val === 0 ? "-" : format(",.4r")(val);
    },
    priceFormatTwoDecimal: function(val) {
      return val === null || val === 0 ? "-" : format(",.2f")(val);
    },
  },
  methods: {
    // ================= user interactions ====================
    _pickedAsset() {
      this.getColumn();
      this.setYAxisLimits();
      this.setYAxisLimits2();
      this.renderComparisonChartMethod();
      this.renderCorrelationsMethod();
    },
    // ==================== valuations ====================
    dataPrep() {
      this.selectedDays = lengthByDate(
        "6M",
        this.histData.map((d) => d.date),
      );
      this.chartData = this.processData.toSlice(
        this.histData,
        this.selectedDays,
      );
    },
    setYAxisLimits() {
      this.minMaxYAxis = this.processData.minMax(this.chartData, "high", "low");
    },
    setYAxisLimits2() {
      this.minMax1YAxis = this.processData.minMax(
        this.chartData,
        "close",
        "close",
      );
      this.minMax2YAxis = this.processData.minMax(
        this.chartData,
        this.selectedColumn,
        this.selectedColumn,
      );
    },
    valuateRV() {
      this.priceModel = [];
      this.retModel = [];
      let _this = this;
      let asset;
      this.models.forEach(function(d) {
        if (d.asset === "Intercept") {
          asset = "int";
        } else if (d.asset === "price_e") {
          asset = "price_e";
        } else {
          _this.columns.forEach(function(_, i) {
            if (d.asset.indexOf(_this.columns[i]) > -1) {
              asset = _this.columns[i];
            }
          });
        }
        if (d.model_type === "model") {
          if (asset === "price_e") {
            _this.retModel.push({ asset: asset, beta: d.relative_value });
          }
        } else {
          _this.priceModel.push({ asset: asset, beta: d.relative_value });
        }
      });

      this.valuationInputs = this.histData[this.histData.length - 1];
      let rv = 0;
      let idx;
      this.priceModel.forEach(function(d) {
        idx = d.asset;
        if (idx === "int") {
          rv += d.beta;
        } else {
          rv += d.beta * Math.log(_this.valuationInputs[idx]);
        }
      });

      this.relativeValue = [];
      let expRV = Math.exp(rv);
      this.rv = expRV;
      let mrSpeed = _this.retModel[0].beta;
      let y = Math.log(this.valuationInputs["close"]);
      this.dateList.forEach(function(d) {
        _this.relativeValue.push({
          date: d,
          rv: expRV,
          path: Math.exp(y),
        });
        y = y + mrSpeed * (y - rv);
      });
    },
    // ==================== helpers ====================
    getColumn() {
      let name = this.models[this.pickedAsset + 1].asset;
      let _this = this;
      this.columns.forEach(function(d) {
        if (name.indexOf(d) > -1) {
          _this.selectedColumn = d;
        }
      });
    },
    addNames() {
      let _this = this,
        sw,
        i;
      this.correlColNames = [];
      this.correlLongNames = [];
      this.correlColumns.forEach(function(d) {
        if (d === _this.currencyString.currency_name) {
          _this.correlColNames.push(d);
          _this.correlLongNames.push(d);
        } else {
          sw = true;
          i = -1;
          while (sw === true) {
            i += 1;
            if (
              i >= _this.variablesId.length ||
              _this.variablesId[i].indexOf(d) > -1
            ) {
              sw = false;
            }
          }
          //_this.correlColNames.push(_this.variables[i].split(/\s/)[0]);
          _this.correlColNames.push(_this.variables[i]);
          _this.correlLongNames.push(_this.variables[i]);
        }
      });
    },
    updateScreenWidth() {
      this.screenWidth = window.innerWidth;
    },
    // ================= render charts ====================
    renderCorrelationsMethod() {
      if (this.correlation.length === 0) {
        return;
      }
      this.svgNodeCorr = this.D3ChartCorrelation.setSVG(
        0.5,
        15,
        0.5,
        115,
        0.5,
        20,
        0.5,
        35,
      );
      // === set axis
      this.svgNodeCorr = this.D3ChartCorrelation.setBandAxis(
        this.svgNodeCorr,
        this.correlColumns,
        JSON.parse(JSON.stringify(this.correlColumns)).reverse(),
        this.correlColNames,
        JSON.parse(JSON.stringify(this.correlColNames)).reverse(),
        false,
        false,
      );
      // === paint rects
      let opacity = 0.95;
      this.D3ChartCorrelation.correlation(
        this.svgNodeCorr,
        this.correlation,
        this.correlLongNames,
        this.color,
        "RVCORR",
        "x",
        "y",
        "correl",
        1,
        opacity,
        format(this.currencyFormat),
        this.selectedColumn,
        this.colorTheme,
      );
      // === texts
      let _this = this;
      let data = [];
      this.correlColumns.forEach(function(d, i) {
        data.push({ x: d, name: _this.correlColNames[i] });
      });
      this.D3ChartCorrelation.text(
        this.svgNodeCorr,
        data,
        "x",
        "x",
        "name",
        "correl",
        "0.85rem",
        this.svgNodeCorr.x.bandwidth() / 2,
        this.svgNodeCorr.y.bandwidth() / 2,
        "middle",
        "central",
        0,
        textactive(this.colorTheme),
        false,
      );
      // add the vertical color legend
      let legendMargin = {
        top: 0,
        bottom: 40,
        left: 0,
        right: 30,
      };
      this.D3ChartCorrelation.vColorLegend(
        this.svgNodeCorr,
        [-1, -0.75, -0.5, -0.25, 0, 0.25, 0.5, 0.75, 1].map((d) =>
          _this.color(d),
        ),
        [-1, -0.75, -0.5, -0.25, 0, 0.25, 0.5, 0.75, 1],
        legendMargin,
        [-1, 1],
        50,
        opacity,
        ".1f",
      );
    },
    renderComparisonChartMethod() {
      if (this.chartData.length === 0) {
        return;
      }
      this.setYAxisLimits2();
      // === set SVG canvas
      this.svgNodeComp = this.D3ChartComparison.setSVG(
        0.5,
        20,
        0.5,
        60,
        0.5,
        30,
        0.5,
        60,
      );
      // === set axis
      this.svgNodeComp = this.D3ChartComparison.setDoubleAxis(
        this.svgNodeComp,
        this.chartData,
        this.minMax1YAxis,
        this.minMax2YAxis,
        this.dateFormat,
        60,
        8,
        format(this.currencyFormat),
        format(this.currencyFormat),
        colorExpo(this.colorTheme),
        whiteGray(this.colorTheme),
      );
      // === main asset line
      this.D3ChartComparison.line(
        this.svgNodeComp,
        this.chartData,
        colorExpo(this.colorTheme),
        2,
        "close",
      );
      // === selected asset line
      this.D3ChartComparison.line2Axis(
        this.svgNodeComp,
        this.chartData,
        whiteGray(this.colorTheme),
        2,
        this.selectedColumn,
      );
      // === add hover Fx
      this.D3HoverRV.hoverFct(
        this.svgNodeComp,
        this.chartData,
        "RVC",
        this.dateFormat,
        this.currencyFormat,
        colorExpo(this.colorTheme),
        textactive(this.colorTheme),
        grayLightBackground(this.colorTheme),
        textactive(this.colorTheme),
        this.svgNode,
        this.svgNodeComp,
        this.selectedColumn,
        this.colorTheme,
        this,
      );
    },
    renderMainChartMethod() {
      if (this.chartData.length === 0) {
        return;
      }
      // === set SVG canvas
      this.svgNode = this.D3Chart.setSVG(
        0.025,
        5,
        0.5,
        60,
        0.05,
        50,
        0.025,
        12,
      );
      // === set axis
      this.setYAxisLimits();
      let minMax = this.processData.minMax(
        this.relativeValue,
        "rv",
        "rv",
        this.minMaxYAxis,
      );
      this.svgNode = this.D3Chart.setAxis(
        this.svgNode,
        this.chartData.concat(this.relativeValue),
        minMax,
        this.dateFormat,
        60,
        8,
        false,
        [],
        true,
        true,
        false,
        [],
        false,
      );
      this.isCandles = noLiquidity(this.chartData);
      // === add historical candles
      if (this.isCandles) {
        this.svgNode = this.D3Chart.candles(
          this.svgNode,
          this.chartData,
          colorExpo(this.colorTheme),
          dnCandles(this.colorTheme),
          "RV",
          0.6,
          0.6,
          colorExpo(this.colorTheme),
          dnCandles(this.colorTheme),
          1,
        );
      } else {
        let minY = this.svgNode.yAxis.scale().domain()[0];
        this.chartData.forEach((d) => (d.zero = minY));

        this.D3Chart.linesArea(
          this.svgNode,
          this.chartData,
          colorExpo(this.colorTheme),
          "rgba(0,0,0,0)",
          2,
          colorExpoAlpha(this.colorTheme),
          "close",
          "zero",
          false,
          1,
          false,
          true,
          "upperLineRV",
          "lowerLineRV",
          "areaRV",
        );
      }
      // === add relative value path
      this.D3Chart.linesArea(
        this.svgNode,
        this.relativeValue,
        colorFwd,
        colorExpo(this.colorTheme),
        2,
        darkFwdAlpha2(this.colorTheme),
        "rv",
        "path",
        true,
        2,
      );
      // === add hover Fx
      this.D3HoverRV.hoverFct(
        this.svgNode,
        this.chartData,
        "RV",
        this.dateFormat,
        this.currencyFormat,
        colorExpo(this.colorTheme),
        textactive(this.colorTheme),
        grayLightBackground(this.colorTheme),
        textactive(this.colorTheme),
        this.svgNode,
        this.svgNodeComp,
        this.selectedColumn,
        this.colorTheme,
        this,
      );
      // === add hover Fx for Forecast Chart/part
      this.D3HoverRVForecast.hoverFct(
        this.svgNode,
        this.relativeValue,
        "RVF",
        this.dateFormat,
        this.currencyFormat,
        colorFwd,
        textactive(this.colorTheme),
        colorExpo(this.colorTheme),
        textactive(this.colorTheme),
        this.colorTheme,
      );
    },
    // ================= animations ====================
    expandLeftAnimation() {
      if (!this.expandLeft) {
        this.hideRight = true;
        setTimeout(() => {
          this.expandLeft = !this.expandLeft;
        }, 50);
        for (let i = 0; i < 22; i++) {
          setTimeout(() => {
            this.renderComparisonChartMethod();
            this.renderCorrelationsMethod();
          }, (i + 1) * 50);
        }
      } else {
        this.expandLeft = !this.expandLeft;
        setTimeout(() => {
          this.hideRight = false;
        }, 100);
        setTimeout(() => {
          this.renderMainChartMethod();
          this.renderComparisonChartMethod();
          this.renderCorrelationsMethod();
        }, 300);
      }
    },
    expandRightAnimation() {
      if (!this.expandRight) {
        this.hideLeft = true;
        setTimeout(() => {
          this.expandRight = !this.expandRight;
        }, 50);
        for (let i = 0; i < 22; i++) {
          setTimeout(() => {
            this.renderMainChartMethod();
          }, (i + 1) * 50);
        }
      } else {
        this.expandRight = !this.expandRight;
        setTimeout(() => {
          this.hideLeft = false;
        }, 100);
        setTimeout(() => {
          this.renderMainChartMethod();
          this.renderComparisonChartMethod();
          this.renderCorrelationsMethod();
        }, 300);
      }
    },
    callWidth() {
      this.updateScreenWidth();

      this.renderMainChartMethod();
      this.renderComparisonChartMethod();
      this.renderCorrelationsMethod();
    },
    // ================== API calls ====================
  },
};
</script>

<style scoped>
.p-dropdown {
  background: var(--transparent);
}
.container-sidebarHidden {
  height: 100%;
  display: flex;
  justify-content: flex-end;
}
.sidebarHidden {
  max-width: 16px;
}
.container-title--select {
  display: flex;
  align-items: center;
  font-size: 1rem !important;
  min-height: 3.1rem;
}
.first-legends-container {
  position: absolute;
  left: 65px;
  top: 20px;
  z-index: 0;
}
.second-legends-container {
  position: absolute;
  left: 15px;
  top: 5px;
}
/* @media (min-width: 1440px) {
  .container-title--select {
    min-height: 40px;
  }
  .first-legends-container {
    top: 7vh;
  }
  .second-legends-container {
    top: 110px;
  }
} */
</style>
